export const tasksQueriesKeys = {
  GET_COMMENTS_AND_MEDIA: 'get_comments_and_media',
  GET_PROJECT_USERS: 'get_project_users',
  GET_TASK: 'get_task',
  GET_TASK_TITLE_SUGGESTION: 'get_task_title_suggestion',
  GET_PROJECT_MEMBERS: 'get_teams_members',
  GET_PROJECT_TEAMS: 'get_teams_teams',
  GET_PROJECT_CONTACTS: 'get_teams_contacts',
  GET_RECENT_ASSIGNED: 'get_recent_assigned'
}
